export const Currency = '$';